/**
 * Compact in-progress badge for the RMA page header when fetchRma reports active bulk participation.
 */
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import IconProcessing from "../../../../../components/icons/icon-processing/icon-processing";
import Icon from "../../../../../components/icons/icon/icon";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { BULK_RMA_ACTION } from "../../../../../services/api/bulk-rma-action-types";
import { IRmaBulkRmaAction } from "../../rma-types";
import "./rma-page-bulk-action-notice.scss";

const DASHBOARD_RETURNS_SCOPE = "dashboard-returns-page";

const ACTION_TITLES: Record<BULK_RMA_ACTION, string> = {
    [BULK_RMA_ACTION.MARK_DONE]: "BULK_RMA_PAGE_MARK_DONE_IN_PROGRESS",
} as const;

interface IProps {
    bulkAction: IRmaBulkRmaAction;
}

const RmaPageBulkActionNotice: React.FC<IProps> = ({ bulkAction }) => {
    const { getTranslation } = useDashboardTranslation();
    const title = getTranslation(ACTION_TITLES[bulkAction.action], DASHBOARD_RETURNS_SCOPE);

    return (
        <div className="rma-page-bulk-action-notice">
            <div className="rma-page-bulk-action-notice__icon">
                <Icon Component={IconProcessing} />
            </div>
            <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                {title}
            </FontBody2>
        </div>
    );
};

export default RmaPageBulkActionNotice;
